function FunnelRow({ label, value, max }) {
  const pct = max > 0 ? Math.round((value / max) * 100) : 0;
  return (
    <div className="partner-funnel-row">
      <span className="partner-funnel-row__label">{label}</span>
      <div className="partner-funnel-row__track" aria-hidden="true">
        <div className="partner-funnel-row__fill" style={{ width: `${pct}%` }} />
      </div>
      <strong className="partner-funnel-row__value">{value}</strong>
    </div>
  );
}

export default function PartnerWhatsappFunnel({ funnel = [] }) {
  const max = Math.max(...funnel.map((step) => step.count || 0), 1);

  return (
    <div className="partner-whatsapp-funnel">
      {funnel.map((step) => (
        <FunnelRow key={step.key} label={step.label} value={step.count || 0} max={max} />
      ))}
    </div>
  );
}
